import { render, staticRenderFns } from "./interaction-header-component.vue?vue&type=template&id=1d6bc0f6&"
import script from "./interaction-header-component.vue?vue&type=script&lang=ts&"
export * from "./interaction-header-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports